
import { Tbl_sportEdit } from './tbl_sportEdit';
import { Tbl_sportList } from './tbl_sportList';
import { Tbl_sportShow } from './tbl_sportShow';
import { Tbl_sportCreate } from './tbl_sportCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_sportList,
    edit: Tbl_sportEdit,
    show: Tbl_sportShow,
    create: Tbl_sportCreate,
    icon: MapIcon
};
            